<template lang="pug">
FCard.FStepCard(
  color="transparent"
  :style="style"
  :class="classes"
)
  .FStepCard__circle
  span.FStepCard__stepNumber {{ stepNumber >= 10 ? stepNumber : `0${stepNumber}` }}
  h5.FStepCard__title {{ title }}
  p.FStepCard__text {{ text }}
</template>

<style lang="stylus">
.FStepCard
  max-width rem(560)
  padding rem(24) rem(16) rem(24) rem(72)
  cursor pointer
  transition background-color 0.3s var(--transition--ease-out), opacity 0.3s var(--transition--ease-out)

  &--highlighted
    background 'rgba(%s, 0.6)' % var(--color--secondary--light-2--rgb)

  &--hidden
    opacity 0

  +media-down('sm')
    max-width rem(304)
    padding rem(24) rem(16)

.FStepCard__circle
  position absolute
  top rem(24)
  left rem(16)
  width rem(24)
  height rem(24)
  border-radius 50%
  background-color var(--FStepCard--circle-color)

  +media-down('sm')
    display none

.FStepCard__stepNumber
  use-font('overline')
  letter-spacing rem(1)
  color var(--color--success--dark-2)

.FStepCard__title
  color var(--color--neutral--dark-5)
  margin-bottom rem(4)

.FStepCard__text
  use-font('body-2')
  color var(--color--secondary)
</style>

<script setup lang="ts">
import type { Color } from '@fifteen/design-system-vue';

export interface FStepCardProps {
  /**
   * Step number of the card
   */
  stepNumber: number;
  /**
   * Title of the card
   */
  title: string;
  /**
   * Text of the card
   */
  text: string;
  /**
   * Color of the card's circle
   */
  circleColor?: Color;
  /**
   * Whether the card is highlighted
   */
  highlighted?: boolean;
  /**
   * Whether the card is hidden
   */
  hidden?: boolean;
}

const props = withDefaults(defineProps<FStepCardProps>(), {
  highlighted: false,
  hidden: false,
  circleColor: 'info',
});

const style = computed(
  (): Style => ({
    '--FStepCard--circle-color': getCssColor(props.circleColor),
  })
);

const classes = computed(() => ({
  'FStepCard--highlighted': props.highlighted,
  'FStepCard--hidden': props.hidden,
}));
</script>
